import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeFormatPipe } from './pipe/time-format.pipe';

import { NgxPaginationModule } from 'ngx-pagination';
import { TemplatePaginationComponent } from './Components/template-pagination/template-pagination.component';
import { TextFilterTableComponent } from './Components/text-filter-table/text-filter-table.component';
import {InlineSVGModule} from "ng-inline-svg-2";
import {NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {SelectFilterComponent} from "@lcms/shared/lazy-load-select";

@NgModule({
  imports: [CommonModule, NgxPaginationModule, InlineSVGModule, NgbDropdownToggle, TranslateModule, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, SelectFilterComponent],
  declarations: [
    TimeFormatPipe,
    TemplatePaginationComponent,
    TextFilterTableComponent,
  ],
  exports: [TimeFormatPipe, TemplatePaginationComponent ,TextFilterTableComponent],
})
export class SharedHelpersModule {}
